import Image from "next/image"

const EventMakingSectionIndividual = () => {
    return (
        <div className="z-40">
            <div className="relative bg-gradient-to-t from-black">
                <div className="h-screen w-full overflow-hidden">
                    <Image
                        src="https://passticketscdn.azureedge.net/frontend/fireworks (2).png"
                        alt="bit rate"
                        width={0}
                        height={0}
                        layout="responsive"
                        className="h-screen w-full bg-cover bg-center opacity-40"
                    />
                </div>

                <div className="h-full w-full">
                    <p className="W-20 absolute top-20 truncate break-words text-xl font-bold text-white lg:top-40 lg:mx-36 lg:leading-9">
                        صناعة الفعاليات <br /> في باس تيكتس
                    </p>
                    <div className="absolute top-36 z-10 flex flex-col gap-4 text-right text-white lg:top-72 lg:mx-36 lg:w-2/4">
                        <p className="text-2xl font-bold text-white lg:text-start lg:text-4xl lg:leading-9">
                            صناعة الفعاليات للافراد
                        </p>
                        <p className="text-right text-xl font-normal text-white lg:leading-10">
                            نحن سعداء بأن نكون جزءًا من صناعة حدثك الخاص الذي
                            يعني لك الـكثير، بدءًا من أعياد الـميلاد، والذكرى
                            السنوية، والتقاعد، والانجازات وتـحديد جنس الجنين
                            وحـفلات الـتخرج وغـيرهـا الـكثير.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventMakingSectionIndividual
